import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';

import { ContentStory } from './story-content.model';
import { StoryContentService } from './story-content.service';
import { getStoryBackgroundImage } from './story-content.utils';

@Component({
    selector: 'ms-story-preview',
    templateUrl: './story-preview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgOptimizedImage, NgClass],
})
export class StoryPreviewComponent implements OnChanges {
    @Input() story: ContentStory;
    @Input() stretch: boolean;
    @Input() more: string;
    @Input() priority: boolean;
    @Output() open = new EventEmitter<void>();
    @Output() view = new EventEmitter<void>();

    @HostBinding('class') className = 'story-preview';
    @HostBinding('class.with-border') get borderClass(): boolean {
        return !this.viewed;
    }

    viewed: boolean;
    background?: string;

    constructor(private storyService: StoryContentService) {
        this.storyService.viewedChange.pipe(takeUntilDestroyed()).subscribe(() => {
            const viewed = this.viewed;

            this.setViewed();

            if (viewed !== this.viewed) {
                this.view.emit();
            }
        });
    }

    ngOnChanges(changes: ISimpleChanges<StoryPreviewComponent>): void {
        if (changes.story) {
            this.background = getStoryBackgroundImage(this.story, this.stretch);
            this.setViewed();
        }
    }

    @HostListener('click', ['$event'])
    openStory(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.open.emit();
    }

    private setViewed(): void {
        this.viewed = this.storyService.isViewed(this.story);
    }
}
